import { render, staticRenderFns } from "./orginalReportCard.vue?vue&type=template&id=43f12e9f&scoped=true"
import script from "./orginalReportCard.vue?vue&type=script&lang=js"
export * from "./orginalReportCard.vue?vue&type=script&lang=js"
import style0 from "./orginalReportCard.vue?vue&type=style&index=0&id=43f12e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f12e9f",
  null
  
)

export default component.exports